import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../features/store';
import { THEME } from '../features/Theme/slice';

interface SurveyProgressBarProps {
  currentStep: number;
  stepCount: number;
  className?: string;
}

const Stepper = ({
  currentStep,
  stepCount,
  className,
}: SurveyProgressBarProps) => {
  const array = Array.from({ length: stepCount }, (_, i) => i);
  const { colors, color } = useSelector((state: RootState) => state[THEME]);

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        gap: 4,
      }}
      className={className}
    >
      {array.map((_, i) => (
        <div
          key={i}
          style={{
            width: `100%`,
            height: 4,
            backgroundColor:
              currentStep === i
                ? color === 'dark'
                  ? colors.primary['1']
                  : colors.primary['7']
                : colors.primary['6'],
          }}
        ></div>
      ))}
    </div>
  );
};

export default Stepper;
